<template lang="pug">
div
  .conteudo-container
    el-table.table(
      :data="dadosWithColor"
    )
      template(slot="empty")
        | Nenhum processo encontrado.
      el-table-column(
        label="%",
        prop="nome"
        width="100"
        :formatter="porcentagem"
      )
      el-table-column(
        label="Setores",
        prop="label",
        align="left",
        width="220"
      )
      el-table-column(
        label="Quantidade de Processos",
        prop="valor"
        align="center",
      )
        template(slot-scope="scope")
          div.tabela
            .content-tabela(:style="`--color: ${scope.row.color}`")
              span {{ scope.row.valor }}
    app-plotly.grafico(nomeDiv="graficoProcessoEmAnaliseSetores", :dados="graficoDados", :layout="layout", :centralizarGrafico="true")
  span.total-processos Total de processos: {{totalDados}}
</template>

<script>
import AppPlotly from '@/components/AppPlotly.vue'
import _ from 'lodash'
import { mapActions } from 'vuex'

export default {
  components: {
    AppPlotly
  },

  async created () {
    this.dadosLabels = await this.getListaProcessosSetor()
  },

  data () {
    return {
      colors: ['#F2A74B', '#038C65', '#1C79A6', '#0F4786', '#A61C5C',
        '#FF6633', '#FFB399', '#FF33FF', '#FFFF99', '#00B3E6',
        '#E6B333', '#3366E6', '#999966', '#99FF99', '#B34D4D',
        '#80B300', '#809900', '#E6B3B3', '#6680B3', '#66991A',
        '#FF99E6', '#CCFF1A', '#FF1A66', '#E6331A', '#33FFCC',
        '#66994D', '#B366CC', '#4D8000', '#B33300', '#CC80CC',
        '#66664D', '#991AFF', '#E666FF', '#4DB3FF', '#1AB399',
        '#E666B3', '#33991A', '#CC9999', '#B3B31A', '#00E680',
        '#4D8066', '#809980', '#E6FF80', '#1AFF33', '#999933',
        '#FF3380', '#CCCC00', '#66E64D', '#4D80CC', '#9900B3',
        '#E64D66', '#4DB380', '#FF4D4D', '#99E6E6', '#6666FF'],
      loading: true,
      dadosLabels: []
    }
  },

  computed: {

    dadosWithColor () {
      if (!this.dadosLabels) {
        return []
      }
      return this.dadosLabels.map((dado, index) => ({
        ...dado,
        color: this.colors[index]
      }))
    },

    graficoDados () {
      if (_.isEmpty(this.dadosLabels)) {
        return []
      }

      const graficoDados = [{
        values: [],
        labels: [],
        domain: { column: 0 },
        name: 'Processos Processos Em análise',
        hoverinfo: 'label+percent',
        textinfo: 'none',
        hole: 0.58,
        type: 'pie',
        marker: {
          colors: []
        }
      }]

      this.dadosWithColor.forEach((dado) => {
        graficoDados[0].labels.push(dado.label)
        graficoDados[0].values.push(dado.valor)
        graficoDados[0].marker.colors.push(dado.color)
      })

      return graficoDados
    },
    hasData () {
      return !_.isEmpty(this.dados)
    },
    layout () {
      return {
        showlegend: false,
        width: 280,
        height: 300,
        annotations: [
          {
            font: {
              size: 20
            },
            showarrow: false,
            text: this.totalDados,
            x: 0.5,
            y: 0.5
          }
        ]
      }
    },
    totalDados () {
      return this.dadosLabels.reduce((total, dado) => total + dado.valor, 0)
    }
  },
  methods: {
    ...mapActions({
      getListaProcessosSetor: 'dashboardRelatorios/getListaProcessosSetor'
    }),
    porcentagem (row) {
      return ((row.valor * 100) / this.totalDados).toFixed(2)
    }
  }
}
</script>
<style lang="scss" scoped>
.main {
  padding: 0 20px;
}

.total-processos {
  color: #92959a !important;
  font-size: 20px;
}

.conteudo-container {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.table {
  width: 70%;
  flex: unset;
}

.grafico {
  width: auto !important;
}

.tabela {
  display: flex;
  justify-content: center;
  color: white;

  .content-tabela {
    width: 72px;
    background-color: var(--color);
  }
}

.el-tabs--border-card {
  border-bottom: 0;
}

.el-tabs--border-card > .el-tabs__header .el-tabs__item {
  font-size: 16px;
  height: auto;
}

.radioButton {
  display: flex;
  justify-content: center;
}

/deep/ .el-tabs__item {
  color: #3498db;
}

/deep/ .el-tabs__active-bar {
  background-color: #3498db;
}

@media (max-width: 780px) {
  .conteudo-container {
    flex-direction: column;
  }
}

</style>



// WEBPACK FOOTER //
// src/screens/relatorios/components/gerais/GraficoProcessoSetor.vue